import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { ResellerOrderDetailPage } from "./reseller-order-detail";
import { PipesModule } from "../../pipes/pipes.module";

@NgModule({
  declarations: [ResellerOrderDetailPage],
  imports: [IonicPageModule.forChild(ResellerOrderDetailPage), PipesModule],
})
export class ResellerOrderDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/reseller-order-detail/reseller-order-detail.module.ts